module.exports = __webpack_public_path__ + "img/plate_photo_9.2c00af64.jpg";